import { render, staticRenderFns } from "./serviceBox.vue?vue&type=template&id=04a364f6&scoped=true&"
import script from "./serviceBox.vue?vue&type=script&lang=js&"
export * from "./serviceBox.vue?vue&type=script&lang=js&"
import style0 from "./serviceBox.vue?vue&type=style&index=0&id=04a364f6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a364f6",
  null
  
)

export default component.exports